import {Component} from '@angular/core';
import {formatCurrency, formatNumber} from '@angular/common';
import {MatDialog} from '@angular/material/dialog';

export interface DebitInterest {
  level: string;
  interestPercentage: number;
  linkId: string;
  linkPercentage: number;
  storePercentage: number;
  minimumPercentage: number;
  startDate: string;
}

@Component({
             selector: 'app-detail-table',
             templateUrl: './debit-interest-table.component.html',
             styleUrls: ['../../detail-screen/detail-screen.component.css'],
           })
export class DebitInterestTableComponent {
  restrictedData: boolean;
  tableColumns: string[];
  tableData: DebitInterest[];
  emptyValuePlaceholder = '-';
  errorText: string;
  showTable: boolean;

  constructor(public dialog: MatDialog) {
    this.tableColumns = [];
    this.tableData = [];
  }

  getAmount(value) {
    if (this.restrictedData) {
      return value;
    } else {
      if (value || value === 0) {
        value = formatNumber(value, 'en-US', '1.3-3');
      } else {
        value = this.emptyValuePlaceholder;
      }
      return value;
    }
  }
}
